import './styles/App.css';

import './styles/home.css';
import './styles/inputs.css';
import './styles/steps.css';
import './styles/obrigado.css';
import './styles/termos.css';
import './styles/header.css';
import './styles/footer.css';
import './styles/pdf.css';
import './styles/login.css';
import './styles/userSearch.css';
import './styles/pagamentos.css';
import './styles/index.css';
import './styles/modal.css';
import './styles/peticao.css';
import './styles/alert.css';
import './styles/floatingChat.css';
import './styles/floatingVideo.css';
import './styles/author.css';
import './styles/verify-account.css';
import './styles/advogados.css';

import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Header from './components/header';
import Footer from './components/footer';
import Home from './pages/home';
import Revisor from './pages/revisao';
import Termos from './pages/termos';
import Obrigado from './pages/obrigado';
import Login from './pages/login';
import QuemSomos from './pages/quemSomos';
import UserArea from './pages/userArea';
import AdvogadosParceiros from './pages/advogadosParceiros.js';
import Ajuda from './pages/ajuda.js';
import ProcessandoPagamento from './pages/processandoPagamento.js';
import VerifyAccount from './pages/verifyAcc.js';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './context/ProtectedRoutes';
import ScrollToTop from './utils/scrollToTop';

import { AlertProvider } from './context/alertContext';
import FloatingChat from './context/chatContext';

import { RoleProvider } from './context/roleContext';

import { CooldownProvider } from './context/cooldownContext.js';

import { FicharioProvider } from './context/ficharioContext.js';

import { LoadingProvider } from './context/loadingContext.js';
import LoadingOverlay from './components/loadingOverlay.js';

import RouterPainel from './pages/routerPainel';

import { useState } from 'react';
import { ChatContext } from './hooks/useChat.js';

import CaptchaGate from './components/captchaGate.js';

import { HelmetProvider } from "react-helmet-async";

import { UTMProvider } from './context/UTMContext.js';

// IMPORTAÇÃO DO AVISO DE COOKIES
import CookieConsent from "react-cookie-consent";

function App() {

  const [isChatOpen, setIsChatOpen] = useState(false);

  return (
    <HelmetProvider>
    <AuthProvider>
      <Router>
      <UTMProvider>
      <LoadingProvider>
      <LoadingOverlay />
      <RoleProvider>
      <AlertProvider>
      <FicharioProvider>
      <CaptchaGate>
      <ChatContext.Provider value={{ isChatOpen, setIsChatOpen }}>
        <div className="App">
          
            <ScrollToTop/>
            <Header/>
            <div className="main-content">
              <CooldownProvider>
              <Routes>
                <Route path="/" element={<AdvogadosParceiros />} />
                <Route path="/revisao" element={<Revisor />} />
                <Route path="/termos" element={<Termos />} />
                <Route path="/advogados-credenciados" element={<AdvogadosParceiros />} />
                <Route path="/ajuda" element={<Ajuda />} />
                <Route path="/processando-pagamento" element={<ProcessandoPagamento />} />
                <Route path="/verify-account" element={<VerifyAccount />} />
                {/* <Route 
                  path="/processando-pagamento" 
                  element={
                    <ProtectedRoute>
                      <ProcessandoPagamento />
                    </ProtectedRoute>
                  } 
                /> */}
                <Route 
                  path="/obrigado" 
                  element={
                    <ProtectedRoute>
                      <Obrigado />
                    </ProtectedRoute>
                  } 
                />
                <Route path="/quem-somos" element={<QuemSomos />} />
                <Route
                  path="/router"
                  element={
                    <ProtectedRoute>
                      <RouterPainel />
                    </ProtectedRoute>
                  }
                />
                <Route 
                  path="/user-area" 
                  element={
                    <ProtectedRoute>
                      <UserArea />
                    </ProtectedRoute>
                  } 
                />
                <Route path="/login" element={<Login />} />
              </Routes>
              </CooldownProvider>
            </div>
            <Footer/>

            {/* BANNER DE COOKIES LGPD */}
            <CookieConsent
              location="bottom"
              buttonText="Entendi e concordo"
              cookieName="revisaja_consentimento"
              style={{ 
                background: "#0f3d35", // Cor verde escura da sua paleta (baseada no footer/header)
                color: "#fff", 
                fontSize: "14px",
                alignItems: "center",
                zIndex: 9999 // Garante que fique acima de modais ou botões flutuantes
              }}
              buttonStyle={{ 
                background: "#7ac142", // Verde claro
                color: "#fff", 
                fontSize: "14px", 
                fontWeight: "bold", 
                borderRadius: "4px",
                padding: "10px 20px"
              }}
              expires={365}
            >
              Utilizamos cookies e tecnologias semelhantes para analisar o tráfego, gravar sessões para melhoria de interface e garantir a segurança do sistema. Ao continuar navegando, você concorda com a nossa Política de Privacidade.
            </CookieConsent>

          {/* <FloatingChat open={isChatOpen} setOpen={setIsChatOpen} /> */}
        </div>
      </ChatContext.Provider>
      </CaptchaGate>  
      </FicharioProvider> 
      </AlertProvider>
      </RoleProvider>
      </LoadingProvider>
      </UTMProvider>
      </Router>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;